<template>
  <div class="nav_top-warpper" v-if="!this.$route.query.hide">

    <div id="navtop" class="fx-full"></div>

    <section v-if="false">
      <div :class="menubarShow?'smalllogo logo fx-none':'biglogo logo fx-none'">
        <div @click="goHome" :class="`g-logo-${menubarShow ? 'small' :'big'}`"></div>
        <!-- <img @click="goHome" src="~@/assets/menu/logo.png"> -->
      </div>
      <div class="fx fx-full w-100 bgTop">
        <div class="product-wrap fx-full">
          <div @click="clickMenu" :class="`menu-${menubarShow ? 'show' :'hide'}`"></div>
        </div>
        <div class="nav_top_right fx-none fx">
          <div class="search" v-if="false">
            <el-input placeholder="搜索" v-model="input5" class="input-with-select" size="small">
              <el-button size="small" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <div class="top-menu fx">
            <div class="action">
              <el-popover placement="bottom-end" v-model="allMenuDialog" :visible-arrow="false" popper-class="user-fee" trigger="hover">
                <div class="console-wrap">
                  <i class="el-icon-close" @click="allMenuDialog = false"></i>
                  <el-select v-model="searchProduct" :popper-append-to-body="false" suffix-icon="el-icon-search" popper-class="search-product-dropdown" class="search-product" filterable
                    placeholder="通过名称/关键词查找产品">
                    <el-option @click.native="clickProductNav(item.Url,item.Title,item.parentTitle, item.ICon, item.ID, item.IsCurrentPageOpen)" v-for="item in filterProductList" :key="item.ID"
                      :label="item.Title" :value="item.ID"></el-option>
                  </el-select>
                  <div class="console-list">
                    <div v-for="(item, index) in allMenu" :key="index">
                      <h5><img :src="item.ICon" alt=""> {{item.Title}}</h5>
                      <p v-for="(child, ii) in item.children" :key="ii">
                        <a @click="clickProductNav(child.Url,child.Title,item.Title, child.ICon, child.ID, child.IsCurrentPageOpen)">{{child.Title}}</a>
                      </p>
                    </div>
                  </div>
                </div>
                <li class="a-hover" slot="reference">全部产品</li>
              </el-popover>
            </div>
            <div class="action">
              <el-popover placement="bottom-end" width="200" :visible-arrow="true" popper-class="user-fee up" trigger="hover">
                <ul @mouseover="mouseOver('fee')" @mouseleave="mouseLeave('fee')">
                  <li v-if="menuPermission(304)" @click="clickTopNav('fee/myAccount')">总览</li>
                  <li v-if="menuPermission(305)" @click="clickTopNav('fee/feeDetail')">收支</li>
                  <li v-if="menuPermission(306)" @click="clickTopNav('fee/orderList')">订单</li>
                  <li v-if="menuPermission(307)" @click="clickTopNav('fee/myProduct')">我的产品</li>
                  <li v-if="menuPermission(335)" @click="clickTopNav('fee/refund')">退订管理</li>
                  <li v-if="menuPermission(334)" @click="clickTopNav('fee/contract')">合同管理</li>
                  <li v-if="menuPermission(337)" @click="clickTopNav('fee/invoiceManage')">发票管理</li>
                  <li v-if="menuPermission(304)" class="li-line"></li>
                  <li v-if="menuPermission(304)" @click="clickTopNav('fee/myAccount')">进入费用中心</li>
                </ul>
                <el-badge class="fee" slot="reference">
                  <span v-if="menuPermission(303)" @click="clickPermissionMenu('fee')">{{$t('menu.fee')}}</span>
                </el-badge>
              </el-popover>
            </div>
            <div class="action">
              <el-popover placement="bottom-end" width="200" :visible-arrow="true" popper-class="user-fee up" trigger="hover">
                <ul @mouseover="mouseOver('newWorkOrder')" @mouseleave="mouseLeave('newWorkOrder')">
                  <li v-if="menuPermission(309)" @click="clickTopNav('newWorkOrder/newWorkOrder')">服务申请</li>
                  <li v-if="menuPermission(310)" @click="clickTopNav('newWorkOrder/myWorkOrder')">我的工单</li>
                </ul>
                <el-badge class="newWorkOrder" slot="reference">
                  <span v-if="menuPermission(308)" @click="clickPermissionMenu('newWorkOrder')">工单</span>
                </el-badge>
              </el-popover>
            </div>
            <div class="action">
              <el-popover placement="bottom-end" width="200" :visible-arrow="true" popper-class="user-fee up" trigger="hover">
                <ul @mouseover="mouseOver('manage')" @mouseleave="mouseLeave('manage')">
                  <li v-if="menuPermission(340)" @click="clickTopNav('manage/APPImpower')">企业微信授权</li>
                  <li v-if="menuPermission(341)" @click="clickTopNav('manage/addressBook')">通讯录</li>
                  <li v-if="menuPermission(342)" @click="clickTopNav('manage/staffSetting')">子账号管理</li>
                  <li v-if="menuPermission(313)" @click="clickTopNav('manage/roleSetting')">角色管理</li>
                </ul>
                <el-badge class="manage" slot="reference">
                  <span v-if="menuPermission(311)" @click="clickPermissionMenu('manage')">{{$t('menu.manage')}}</span>
                </el-badge>
              </el-popover>
            </div>
            <el-badge class="action action-icon shopping-icon" @click.native="GoOfficialWebsite">
              <span title="购物车"><i></i></span>
            </el-badge>
            <div class="action action-icon messages-icon">
              <el-popover placement="bottom-end" width="310" :visible-arrow="true" popper-class="top-popover message-box-popover up" trigger="hover">
                <div class="message-box">
                  <div class="message-box-header">消息中心</div>
                  <div class="message-box-body">
                    <ul>
                      <li v-for="item in messageList" :key="item.ID" @click="clickMessage(item)">
                        <div class="title fx-full">
                          <text-overflow>{{item.Title}}</text-overflow>
                        </div>
                        <div class="fx-none">{{item.AddDate}}</div>
                      </li>
                    </ul>
                    <div class="empty" v-if="!messageList.length">
                      <div class="empty-img fx-ps-center"> <img src="~@/assets/menu/unmessage.png" alt=""></div>
                      <div class="empty-text">暂时没有新的站内消息</div>
                    </div>
                  </div>
                  <div class="message-box-footer fx fx-ps-center">
                    <div class="message-more" @click="clickTopNav('message/allMessage')">查看更多</div>
                  </div>
                </div>
                <el-badge :hidden="unreadMessageCount === 0" :value="unreadMessageCount" class="item-icon" slot="reference">
                  <span title="消息中心" @click="clickTopNav('message/allMessage')" class=""><i></i></span>
                </el-badge>
              </el-popover>
              <!-- <h5>消息中心</h5>
              <ul>
                  <li v-for="item in messageList" :key="item.ID" @click="clickMessage(item)">
                  <p>
                      <a style="color: #fff;">{{item.Title}}</a>
                  </p>
                  <p><span>{{item.AddDate}}</span></p>
                  </li>

                  <p v-if="messageList.length==0" class="un-message">
                  <img src="~@/assets/menu/unmessage.png" alt="">
                  <span>暂时没有新的站内消息</span>
                  </p>
                  <li class="more" @click="clickTopNav('message/allMessage')">查看更多</li>
              </ul>
              <el-badge :hidden="unreadMessageCount === 0" :value="unreadMessageCount" class="item-icon" slot="reference">
                  <span @click="clickTopNav('message/allMessage')" class="messages-icon"><i></i></span>
              </el-badge> -->
            </div>
            <el-badge class="action action-icon el-question">
              <span title="帮助文档" @click="clickHelpUrl"><i></i></span>
            </el-badge>
          </div>
          <el-popover placement="bottom-end" :visible-arrow="true" width="310" popper-class="top-popover user-popover" trigger="hover">
            <div class="user-popover-header fx fx-s-center">
              <div class="fx-none avatar" :style="avatar"></div>
              <div class="fx-full" style="font-weight: blod">
                <text-overflow>{{userName}}</text-overflow>
              </div>
              <div class="logout fx-none" @click="signOut">退出</div>
            </div>
            <div class="user-popover-body">
              <div class="ul">
                <div class="li fx" v-if="menuPermission(315)" @click="clickTopNav('userCenter/authentication/fastAuthentication')">
                  <div>{{$t('menu.authentication')}}</div>
                  <span v-if="authenticationStatus === 3">待认证</span>
                  <span v-else-if="authenticationStatus === 0">审核中</span>
                  <span v-else-if="authenticationStatus === 1">已认证</span>
                  <span v-else-if="authenticationStatus === 2">已驳回</span>
                </div>
                <div class="li fx" v-if="menuPermission(316)" @click="gotoAuthencationInfo(1)">
                  <div>国内推广资料</div>
                  <template v-if="authenticationType !== 0">
                    <span v-if="informationStatus === 0">审核中</span>
                    <span v-else-if="informationStatus === 1">已通过</span>
                    <span v-else-if="informationStatus === 2">已驳回</span>
                    <span v-else>待完善</span>
                  </template>
                </div>
                <div class="li fx" v-if="menuPermission(343)" @click="gotoAuthencationInfo(2)">
                  <div>外贸推广资料</div>
                  <template v-if="authenticationType !== 0">
                    <span v-if="ftInformationStatus === 0">审核中</span>
                    <span v-else-if="ftInformationStatus === 1">已通过</span>
                    <span v-else-if="ftInformationStatus === 2">已驳回</span>
                    <span v-else>待完善</span>
                  </template>
                </div>
                <!-- <div class="li fx" @click="bindPhone">
                  <div>绑定号码</div>
                </div> -->
              </div>
              <ul class="fx">
                <li class="fx-c fx-ps-center" v-if="menuPermission(317)" @click="clickTopNav('userCenter/score')">
                  <div class="tm-link-score"></div>
                  <div class="li-link">会员积分</div>
                </li>
                <li class="fx-c fx-ps-center" @click="clickTopNav('userCenter/information')">
                  <div class="tm-link-information"></div>
                  <div class="li-link">账户安全</div>
                </li>
                <li class="fx-c fx-ps-center" v-if="menuPermission(318)" @click="gotoBusiness">
                  <div class="tm-link-business"></div>
                  <div class="li-link">商家中心</div>
                </li>
              </ul>
            </div>
            <div class="action action-user fx" slot="reference">
              <div class="user-name">{{userName}}</div>
              <div class="avatar" :style="avatar"></div>
            </div>
          </el-popover>
        </div>
      </div>
    </section>
    <!-- 外呼绑定手机号 -->
    <!-- <callBindPhone ref="callBindPhone" /> -->
  </div>
</template>

<script>
// import callBindPhone from '@/components/callBindPhone'
import { logout, listMessage, getAuthenticationInfoSummary } from '@/api/login'
import { removeToken, setCookie, getToken } from '@/base/cookie'
import { accountBalance, selectMyCredit, getAccountInfo, getAuthenticationStatus, getAllMenu, getShortcutMenu, setShortcutMenu, getListOperations, setListOperations, getProductUrl } from '@/api/index'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import logo from '@/assets/newicons/logo.png'
import Vue from 'vue'
import newNavTop from './newNavTop'
export default {
  name: 'nav_top',
  components: {
    // callBindPhone
  },
  data() {
    return {
      input5: '',
      img: require('@/assets/defaultface.png'),
      balance: 0,
      myCredit: 0,
      messageList: [],
      unreadMessageCount: 0,
      authenticationType: null, // 实名认证类型
      authenticationStatus: null, // 实名认证状态
      informationStatus: null, // 完善资料状态
      ftInformationStatus: null, // 外贸完善资料状态
      allMenuDialog: false,
      searchProduct: '',
      allMenu: [],
      shortcutMenu: [],
      productWidth: 0,
      showMenu: 4,
      popoverVisible: false,
      isCollapse: false
    }
  },
  watch: {
    $route(val) {
      this.select(val.path)
    },
    helpDocUrl: {
      deep: true,
      handler: function (val, oldVal) {
        if (val && this.navtop) {
          this.navtop.producturl = val
        }
      }
    },
    helpDocName: {
      deep: true,
      handler: function (val, oldVal) {
        if (val && this.navtop) {
          this.navtop.productname = val
        }
      }
    },
  },
  computed: {
    ...mapState({
      helpDocUrl: state => state.user.helpDocUrl,
      helpDocName: state => state.user.helpDocName
    }),
    avatar() {
      const { avatarUrl } = this.staffInfo
      if (avatarUrl) {
        return `background-image: url(${process.env.VUE_APP_BASE_API}tcloud-fs/fs/readImage?fileId=${avatarUrl}&X-Token=${getToken('X-Token')})`
      }
      return `background-image: url(${this.img})`
    },
    userName() {
      return this.staffInfo.loginName || ''
    },
    routes() {
      return this.$router.options.routes
    },
    staffInfo() {
      return this.$store.state.user.staffInfo
    },
    menubarShow() {
      return this.$store.state.user.isCollapse
    },
    filterProductList() {
      const target = []
      this.allMenu.forEach(x => {
        x.children.forEach(y => {
          target.push({ ...y, ...{ parentTitle: x.Title } })
        })
      })
      return target
    }
  },
  mounted() {
    this.getMessageList()
    this.accountBalance()
    this.selectMyCredit()
    this.getAccountInfo()
    this.getAuthenticationStatus()
    this.select(this.$route.path)
    this.getAllMenu()
    window.onresize = () => {
      this.winResize()
    }

    if (this.$route.query.hide) return

    if (['erp', 'erp-prod'].includes(process.env.VUE_APP_SECRET)) return

    this.$nextTick(() => {
      const vm = new Vue({ el: '#navtop', render: h => h(tl_nav_top) })
      this.navtop = vm.$children[0]
      this.navtop.init({
        logo: {
          url: require('@/assets/newicons/logo.png'), // logo地址
          path: '', // 点击跳转时的路径(完整),默认 在传入router的时候跳转 /home路径 不传router则跳转控制台首页
          title: '控制台', // 显示文案,
          producturl: this.helpDocUrl,
          productname: this.helpDocName
        },
      })
    })
  },

  methods: {
    bindPhone() {
      this.$refs.callBindPhone.init()
    },
    clickHelpUrl() {
      window.open(this.helpDocUrl)
    },
    clickMenu() {
      this.isCollapse = !this.isCollapse
      this.$store.commit('set_isCollapse', this.isCollapse)
    },
    menuPermission(val) {
      return this.staffInfo.accountType.code === 0 || (this.staffInfo.roleIds && this.staffInfo.roleIds.includes(val))
    },
    clickPermissionMenu(name) {
      switch (name) {
        case 'fee':
          if (this.menuPermission(304)) {
            this.clickTopNav('fee/myAccount')
          } else if (this.menuPermission(305)) {
            this.clickTopNav('fee/feeDetail')
          } else if (this.menuPermission(306)) {
            this.clickTopNav('fee/orderList')
          } else if (this.menuPermission(307)) {
            this.clickTopNav('fee/myProduct')
          } else if (this.menuPermission(335)) {
            this.clickTopNav('fee/refund')
          } else if (this.menuPermission(334)) {
            this.clickTopNav('fee/contract')
          } else if (this.menuPermission(337)) {
            this.clickTopNav('fee/invoiceManage')
          }
          break
        case 'newWorkOrder':
          if (this.menuPermission(309)) {
            this.clickTopNav('newWorkOrder/newWorkOrder')
          } else if (this.menuPermission(310)) {
            this.clickTopNav('newWorkOrder/myWorkOrder')
          }
          break
        case 'manage':
          if (this.menuPermission(340)) {
            this.clickTopNav('manage/APPImpower')
          } else if (this.menuPermission(341)) {
            this.clickTopNav('manage/addressBook')
          } else if (this.menuPermission(342)) {
            this.clickTopNav('manage/staffSetting')
          } else if (this.menuPermission(313)) {
            this.clickTopNav('manage/roleSetting')
          }
          break
        default:
          break
      }
    },
    winResize() {
      const that = this
      // try {
      //   if (!this.hide) {
      //     const productWidth = document.querySelector('.product-wrap').clientWidth
      //     const userWidth = document.querySelector('.nav_top_right').clientWidth
      //     const clientWidth = document.querySelector('.nav_top').clientWidth
      //     const logoWidth = document.querySelector('.logo').clientWidth
      //     const fixed = userWidth + logoWidth
      //     if (productWidth + fixed > clientWidth) {
      //       that.productWidth = productWidth
      //       that.showMenu = 2
      //     }
      //     if (that.productWidth + fixed <= clientWidth) {
      //       that.showMenu = 4
      //     }
      //   }
      // } catch (error) {
      //   console.log(error)
      // }

    },
    clickProductNav(path, title, parent, icon, id, currentPage) {
      if (path && currentPage) {
        window.location.href = path
      } else if (path !== null) {
        window.open(path)
      }
    },
    async getAllMenu() {
      const result = await getAllMenu()

      const result2 = await getProductUrl()

      const result3 = await getListOperations()

      const result4 = await getShortcutMenu()

      this.shortcutMenu = result4.data ? result4.data : []

      this.menuList = result.data
      this.commonMenu = result3.data
      result.data.forEach(item => {
        if (item.ParentID === 0) {
          const isSelected = this.shortcutMenu.filter(e => {
            return e.ID === item.ID
          })
          if (isSelected.length > 0) this.$set(item, 'checked', true)
          this.allMenu.push(item)
          this.$set(item, 'children', [])
        } else {
          const isSelected = this.shortcutMenu.filter(e => {
            return e.ID === item.ID
          })
          if (isSelected.length > 0) this.$set(item, 'checked', true)

          var parent = this.allMenu.filter(e => {
            return e.ID === item.ParentID
          })
          if (parent.length > 0) {
            parent[0].children.push(item)
          }
        }
      })
      result2.data.forEach(e => {
        this.menuList.forEach(item => {
          if (item.ID === e.ID) {
            item.Url = e.Url
          }
        })
        this.commonMenu.forEach(item => {
          if (item.id === e.ID) {
            item.path = e.Url
          }
        })
        this.shortcutMenu.forEach(x => {
          if (e.ID === x.ID) {
            x.Url = e.Url
          }
        })
      })
      this.$nextTick(() => {
        this.winResize()
      })
    },
    saveShortcutMenu() {
      var checkShortcutMenu = this.allMenu.filter(e => {
        return e.checked
      })

      this.allMenu.forEach(e => {
        var checkedChild = e.children.filter(e => {
          return e.checked
        })
        checkShortcutMenu = checkShortcutMenu.concat(checkedChild)
      })

      var postData = {
        shortcutMenu: checkShortcutMenu
      }

      setShortcutMenu(postData)
        .then(res => {
          this.$message({
            type: 'success',
            message: res.message
          })
          this.shortcutMenu = checkShortcutMenu
          this.popoverVisible = !this.popoverVisible
          this.$nextTick(() => {
            this.winResize()
          })
        })
    },
    selectChange(item) {
      var shortcutMenu = this.allMenu.filter(e => {
        return e.checked
      })

      this.allMenu.forEach(e => {
        var checkedChild = e.children.filter(e => {
          return e.checked
        })
        shortcutMenu = shortcutMenu.concat(checkedChild)
      })

      if (shortcutMenu.length > 4) {
        this.$message({
          type: 'warning',
          message: '最多选择4个'
        })
        item.checked = false
      }
    },
    GoOfficialWebsite() {
      window.open(process.env.VUE_APP_OW_DOMAIN + 'cart.html')
    },
    select(path) {
      const item = this.routes.find(e => {
        if (e.path === '/') { return }
        return '/' + path.split('/')[1] == e.path
      })
      this.$store.commit('SWITCHMENUBAR', item)
    },
    clickTopNav(path) {
      const url = process.env.VUE_APP_7_OPEN
      window.open(url + path)
    },
    signOut() {
      logout()
        .then(res => {
          removeToken()
          const url = process.env.VUE_APP_7_OPEN
          window.location.href = url + 'login/login?backUrl=' + window.location.href
        })
    },

    gotoAuthencationInfo(val) {
      const path = val === 1 ? 'userCenter/promoteInfo' : 'userCenter/promoteInfoForeign'
      this.clickTopNav(path)
    },
    gotoBusiness() {
      if (this.authenticationStatus === 1) {
        // 是否已经认证完毕
        if (this.authenticationType === 1) {
          // 认证类型为企业的
          this.clickTopNav('businessCenter/businessCenter')
        } else {
          this.$message({
            type: 'warning',
            message: '你不是企业认证用户'
          })
        }
      } else {
        if (this.authenticationStatus === 3) {
          // 未提交认证
          this.$message({
            type: 'warning',
            message: '商家中心需要先进行企业认证'
          })
          this.clickTopNav('userCenter/authentication/authenticationByCompany')
        } else {
          // 未通过认证
          this.$message({
            type: 'warning',
            message: '请耐心等待审核通过'
          })
          this.clickTopNav('userCenter/authentication/fastAuthentication')
        }
      }
    },
    getAuthenticationInfoSummary() {
      getAuthenticationInfoSummary()
        .then(res => {
          this.authenticationStatus = res.data.status.code
          this.authenticationType = res.data.authenticationType ? res.data.authenticationType.code : null
          this.informationStatus = res.data.improveStatus ? res.data.improveStatus.code : null
          this.ftInformationStatus = res.data.foreignStatus ? res.data.foreignStatus.code : null
          this.$store.commit('SETUSERAUTHENTICATION', res.data)
        })
    },
    getAuthenticationStatus() {
      getAuthenticationStatus()
        .then(res => {
          this.$store.commit('SETSTAFFAUTHENTICATIONSTATUS', res.data)
        })
    },
    clickMessage(item) {
      const url = process.env.VUE_APP_7_OPEN
      window.open(url + 'message/detail/' + item.ID)
    },
    mouseOver(dom) {
      document.querySelector(`.${dom} span`).className = 'active'
    },
    mouseLeave(dom) {
      document.querySelector(`.${dom} span`).className = ''
    },
    getMessageList(val) {
      var searchJsonData = {}

      searchJsonData.readStatus = false

      var postData = {
        pageIndex: 1,
        pageSize: 3,
        searchJsonData: searchJsonData
      }

      listMessage(postData)
        .then(res => {
          this.messageList = res.data.list
          this.unreadMessageCount = res.data.recordsTotal
        })
    },
    goHome() {
      const url = process.env.VUE_APP_7_OPEN
      window.location.href = url
    },
    getAccountInfo() {
      getAccountInfo()
        .then(res => {
          if (res.data != null) {
            if (res.data.loginName !== '') {
              setCookie('loginName', res.data.loginName)
            }
            this.$store.commit('SETSTAFFiNFO', res.data)
            this.getAuthenticationInfoSummary()
          }
        })
    },
    accountBalance() {
      accountBalance()
        .then(res => {
          if (res.data != null) {
            this.balance = res.data.balance
            this.$store.dispatch('REQ_DEEP_TASK_LIST')
            this.$store.commit('SETACCOUNTINFO', res.data)
            this.$bus.$emit("reportUpdate")
          }
        })
    },
    selectMyCredit() {
      selectMyCredit()
        .then(res => {
          if (res.data != null) {
            this.myCredit = res.data.sumAmount
            this.$store.commit('SETMYCREDIT', res.data)
          }
        })
    },
    changeLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  margin-top: 8px;
  cursor: pointer;
}
/deep/ {
  .nav_top .logo {
    margin-left: 125px;
    &::before {
      content: " ";
      display: block;
      width: 91px;
      height: 33px;
      // background: red;
      position: absolute;
      left: 66px;
      background-position: center;
      background-size: cover;
      background-image: url("~@/assets/newicons/logo.png");
    }
  }
  .nav_top .logo img {
    display: none;
  }
  .nav_top .logo .no-console {
    margin-left: 0;
  }
}
</style>
